var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "scroll_container flex h-full",
      class: _vm.scrollClasses,
      on: { scroll: _vm.onScrollHandle },
    },
    [_vm._t("default"), _vm._t("loading")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }